import { AuthChannel } from 'components/layout/Auth/ChannelStep';
import api from 'services/api';
import { requestGetAccessToken } from 'services/authServices';

type ContatoApi = {
  contactId: string;
  contact: string;
  contactType: 'EMAIL' | 'PHONE';
};

const normalizar = (contatos: ContatoApi[]): AuthChannel[] => {
  const vistos = new Set<string>();

  return contatos
    .filter((c) => {
      if (!c?.contact || vistos.has(c.contact)) return false;
      vistos.add(c.contact);
      return true;
    })
    .sort((a, b) => a.contactType.localeCompare(b.contactType));
};

const headers = async (): Promise<Record<string, string>> => ({
  access_token: await requestGetAccessToken(),
});

export const getUserChannels = async (
  userId: string
): Promise<AuthChannel[]> => {
  const response = await api.get(
    `industrial/customer/v1/users/${userId}/contacts`,
    { headers: await headers(), params: { 'mfa-eligible': true } }
  );

  return normalizar(response.data ?? []);
};

export const sendToken = async (
  userId: string,
  contactId: string
): Promise<void> => {
  await api.post(
    `industrial/customer/v1/users/${userId}/tokens`,
    { tokenType: 'MFA', contactId, url: null },
    { headers: await headers() }
  );
};
